export default __webpack_public_path__ + "static/media/Busy.46128bbc.mp4";